import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// On every route (pathname) change, jump to the top of the page. Skips when a
// #hash is present so in-page anchor links (e.g. /#about) still scroll to their
// section. Temporarily disables smooth scroll so navigation is an instant jump,
// not an animated scroll from the previous position.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    const root = document.documentElement;
    const prev = root.style.scrollBehavior;
    root.style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    root.style.scrollBehavior = prev;
  }, [pathname, hash]);
  return null;
}
